export const BackgroundContainer = ({ children }) => {
    return <div
        style={{
            backgroundImage: 'url("../landing/assets/img/header-bg.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '100vh',
            padding: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {children}
    </div>
}